import { useDispatch, useSelector } from "react-redux";
import {
  IonAvatar,
  IonCard,
  IonIcon,
  IonItem,
  IonLabel,
  IonSearchbar,
  IonText,
  IonCol,
  IonSegment,
  IonSegmentButton,
} from "@ionic/react";
import { selectUserRoles } from "../../../store/supervisorHome/selectors/selectUserRoles";
import { setUserRolesSearchText } from "../../../store/supervisorHome";
import { selectUserRolesSearchText } from "../../../store/supervisorHome/selectors/selectUserRolesSearchText";
import { selectUserRolesFetchStatus } from "../../../store/supervisorHome/selectors/selectUserRolesFetchStatus";
import { useEffect, useState } from "react";
import {UserRoleAlert} from "../../../components/UserRole/UserRoleAlert"
import {UserRoleNoAlert} from "../../../components/UserRole/UserRoleNoAlert"

export const UserRolesSection: React.FC = () => {
  const dispatch = useDispatch();
  const userRoles = useSelector(selectUserRoles);
  const searchText = useSelector(selectUserRolesSearchText);
  const fetchStatus = useSelector(selectUserRolesFetchStatus);
  const [alertasActive, setAlertasActive] = useState<boolean>(false);
  const [todosActive, setTodosActive] = useState<boolean>(true);


  const rolesWAlert = userRoles.filter(({alerts}) => alerts > 0)


  const [userRolesLength, setUserRolesLentght] = useState(rolesWAlert.length)

  useEffect(() => {
    setUserRolesLentght(userRoles.filter(({alerts}) => alerts > 0).length)
  }, [userRoles])

  return (
    <section>
      <h2 className="ion-margin-horizontal ion-text-nowrap">
        <IonText color="primary">Colaboradores ({alertasActive ? userRolesLength : userRoles.length})</IonText>
      </h2>
      <IonCol size='12'>
        <IonSegment 
          value= {alertasActive ? "alerta" : "todos"} 
          color="primary"
          style={{ maxWidth: '100%', marginBottom: '40px' }}
          mode="ios"
        >
          <IonSegmentButton value="todos" onClick={()=>{setAlertasActive(false); setTodosActive(true)}}>
            <IonLabel style={{display: 'flex', alignItems: 'center'}}>Todos</IonLabel>
          </IonSegmentButton>
          <IonSegmentButton value="alerta" onClick={()=>{setAlertasActive(true); setTodosActive(false); setUserRolesLentght(rolesWAlert.length)}}>
            <IonLabel style={{display: 'flex', alignItems: 'center'}}>Alerta</IonLabel>
          </IonSegmentButton>
        </IonSegment>
      </IonCol>
      <IonSearchbar
        style={{ maxWidth: 360 }}
        placeholder="Buscar colaborador"
        value={searchText}
        onIonChange={({ detail: { value = "" } }) => dispatch(setUserRolesSearchText(value))}
        class="ion-no-padding ion-padding-start ion-padding-bottom"
      ></IonSearchbar>

      {fetchStatus === "pending" && <p>Cargando...</p>}
      {fetchStatus === "fulfilled" && (
        <>
          {userRoles.length === 0 && (
            <IonCard>
              <IonItem lines="none">
                <IonLabel>
                  <IonText color="medium">No se han encontrado usuarios</IonText>
                </IonLabel>
              </IonItem>
            </IonCard>
          )}
          {todosActive ? (
              <IonCol sizeLg="12" sizeMd="12" sizeXs="12">
                <UserRoleNoAlert/>
              </IonCol>
            ) : (
              <IonCol sizeLg="12" sizeMd="12" sizeXs="12">
                <UserRoleAlert/>
              </IonCol>
            )
          }
        </>
      )}
    </section>
  );
};
